import { PaymentMethodEnum } from 'common/enums/PaymentMethodEnum'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import CashOnDeliveryPaymentButton from 'publisher/components/entities/PaymentButtonNew/CashOnDeliveryPaymentButton'
import DLocalBoletoAndPixPaymentButton from 'publisher/components/entities/PaymentButtonNew/DLocalBoletoAndPixPaymentButton'
import DLocalPaymentButton from 'publisher/components/entities/PaymentButtonNew/DLocalPaymentButton'
import FlutterwavePaymentButton from 'publisher/components/entities/PaymentButtonNew/FlutterwavePaymentButton'
import GocardlessPaymentButton from 'publisher/components/entities/PaymentButtonNew/GocardlessPaymentButton'
import MercadoPagoCreditCardPaymentButton from 'publisher/components/entities/PaymentButtonNew/MercadoPagoCreditCardPaymentButton'
import MercadoPagoPixAndBoletoPaymentButton from 'publisher/components/entities/PaymentButtonNew/MercadoPagoPixAndBoletoPaymentButton'
import MolliePaymentButton from 'publisher/components/entities/PaymentButtonNew/MolliePaymentButton'
import PaypalPaymentButton from 'publisher/components/entities/PaymentButtonNew/PaypalPaymentButton'
import PaystackPaymentButton from 'publisher/components/entities/PaymentButtonNew/PaystackPaymentButton'
import { PaypalRestPaymentButton } from 'publisher/components/entities/PaymentButtonNew/paypal-rest-button/index'
import RazorpayPaymentButton from 'publisher/components/entities/PaymentButtonNew/RazorpayPaymentButton'
import SecureAndPayPaymentButton from 'publisher/components/entities/PaymentButtonNew/SecureAndPayPaymentButton'
// import StripeBancontactPaymentButton from 'publisher/components/entities/PaymentButtonNew/StripeBancontactPaymentButton'
import StripeCardPaymentButton from 'publisher/components/entities/PaymentButtonNew/StripeCardPaymentButton'
import { StripeGeneralPaymentButton } from 'publisher/components/entities/PaymentButtonNew/stripe-general-payment-button'
import XenditCardPaymentButton from 'publisher/components/entities/PaymentButtonNew/XenditCardPaymentButton'
import useManagement, { selectors } from 'publisher/hooks/useManagement'
import usePayment, {
  selectors as paymentSelectors,
} from 'publisher/hooks/usePayment'
import React, { useEffect, useState } from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import { useSelectedButtonColor } from 'src/publisher/shared/hooks/use-theme-color/use-selected-button-color'
import { Button } from 'src/shared/components/button/button'
import { PaymentButtonEntityInterface } from 'src/shared/entities/payment-button/payment-button.schema'

export interface PaymentButtonNewProps {
  entity: PaymentButtonEntityInterface
}

const PaymentButtonNew = ({ entity }: PaymentButtonNewProps) => {
  const isScreenshotMode = useManagement(selectors.isScreenshotMode)
  const paymentMethod = usePayment(paymentSelectors.getActivePaymentMethod)
  const isPreview = useManagement(selectors.isPreviewMode)
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
    calculatedTextColor,
    calculatedBackground,
    calculatedHover,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
    textColor: entity.textColor,
    mobileTextColor: entity.mobileTextColor,
    background: entity.background,
    mobileBackground: entity.mobileBackground,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
    hover: entity.hover,
    mobileHover: entity.mobileHover,
  })

  const BaseButton = () => (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <Button
        onClick={() => null}
        disabled={false}
        attrId={entity.htmlAttrId}
        text={entity.text}
        subText={entity.subText}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        textColor={calculatedTextColor.desktop}
        mobileTextColor={calculatedTextColor.mobile}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        lineHeight={calculatedLineHeight.desktop}
        mobileLineHeight={calculatedLineHeight.mobile}
        textFontFamily={calculatedFontFamily.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        subTextColor={entity.subTextColor}
        mobileSubTextColor={entity.mobileSubTextColor}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontStyle={entity.subTextFontStyle}
        subTextFontWeight={entity.subTextFontWeight}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={calculatedHover.desktop}
        mobileHover={calculatedHover.mobile}
        background={calculatedBackground.desktop}
        mobileBackground={calculatedBackground.mobile}
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
      />
    </StyleWrapper>
  )

  if (
    isScreenshotMode ||
    (isPreview && paymentMethod !== PaymentMethodEnum.PaypalRest)
  ) {
    return <BaseButton />
  }

  if (!isClient) return <></>

  switch (paymentMethod) {
    case PaymentMethodEnum.PaypalSoap:
      return <PaypalPaymentButton entity={entity} />
    case PaymentMethodEnum.PaypalRest:
      return (
        <PaypalRestPaymentButton
          entity={entity}
          borderRadius={entity.border}
          backgroundColor={entity.paypal?.backgroundColor}
        />
      )
    //https://app.shortcut.com/systeme/story/73336/revert-stripe
    //       case PaymentMethodEnum.StripeCard:
    // case PaymentMethodEnum.StripeIDeal:
    // case PaymentMethodEnum.StripeBancontact:
    // case PaymentMethodEnum.StripeKlarna:
    //   return <StripeGeneralPaymentButton entity={entity} />
    case PaymentMethodEnum.StripeCard:
      return <StripeCardPaymentButton entity={entity} />
    // case PaymentMethodEnum.StripeBancontact:
    //   return <StripeBancontactPaymentButton entity={entity} />
    case PaymentMethodEnum.StripeBancontact:
    case PaymentMethodEnum.StripeIDeal:
    case PaymentMethodEnum.StripeKlarna:
    case PaymentMethodEnum.StripeMultibanco:
      return <StripeGeneralPaymentButton entity={entity} />
    case PaymentMethodEnum.DlocalCard:
      return <DLocalPaymentButton entity={entity} />
    case PaymentMethodEnum.DlocalBoleto:
    case PaymentMethodEnum.DlocalPix:
      return <DLocalBoletoAndPixPaymentButton entity={entity} />
    case PaymentMethodEnum.MercadoPagoCard:
    case PaymentMethodEnum.MercadoPagoBrCard:
    case PaymentMethodEnum.MercadoPagoCoCard:
    case PaymentMethodEnum.MercadoPagoMxCard:
    case PaymentMethodEnum.MercadoPagoArCard:
    case PaymentMethodEnum.MercadoPagoClCard:
      return <MercadoPagoCreditCardPaymentButton entity={entity} />
    case PaymentMethodEnum.MercadoPagoPix:
    case PaymentMethodEnum.MercadoPagoBoleto:
    case PaymentMethodEnum.MercadoPagoBrPix:
    case PaymentMethodEnum.MercadoPagoBrBoleto:
      return <MercadoPagoPixAndBoletoPaymentButton entity={entity} />
    case PaymentMethodEnum.RazorpayCard:
      return <RazorpayPaymentButton entity={entity} />
    case PaymentMethodEnum.Flutterwave:
      return <FlutterwavePaymentButton entity={entity} />
    case PaymentMethodEnum.Mollie:
      return <MolliePaymentButton entity={entity} />
    case PaymentMethodEnum.Gocardless:
      return <GocardlessPaymentButton entity={entity} />
    case PaymentMethodEnum.CashOnDelivery:
      return <CashOnDeliveryPaymentButton entity={entity} />
    case PaymentMethodEnum.XenditIdCard:
    case PaymentMethodEnum.XenditPhCard:
      return <XenditCardPaymentButton entity={entity} />
    case PaymentMethodEnum.PaystackGhCard:
    case PaymentMethodEnum.PaystackKeCard:
    case PaymentMethodEnum.PaystackNgCard:
    case PaymentMethodEnum.PaystackZaCard:
    case PaymentMethodEnum.PaystackEgCard:
    case PaymentMethodEnum.PaystackCiCard:
      return <PaystackPaymentButton entity={entity} />
    case PaymentMethodEnum.SecureAndPay:
      return <SecureAndPayPaymentButton entity={entity} />
    default:
      return <div />
  }
}

export default PaymentButtonNew
